import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = !!document.head.querySelector("meta[name=rails_development]")
window.Stimulus   = application

export { application }
